module.exports = __webpack_public_path__ + "static/media/food2.f40e2d7d.JPG";